import React from 'react';

import { FontSizePropKey, useCurrentTheme } from 'app/shared/theme';
import { WithSpacingProps } from 'app/shared/components/styleUtils';
import { Typography } from 'app/shared/components/atoms';

interface Props {
  hasError: boolean;
  isSuccessful: boolean;
  isDisabled: boolean;
  isWarning?: boolean;
  invertColors?: boolean;
  'data-qaid'?: string;
  pt?: WithSpacingProps['pt'];
  fontSize?: FontSizePropKey;
  children: React.ReactNode;
}

export const InputHelperText = ({
  children,
  hasError,
  isSuccessful,
  isDisabled,
  isWarning = false,
  invertColors,
  'data-qaid': qaId = 'input-helper-text',
  pt = 1,
  fontSize = 'fontSize50',
}: Props) => {
  const { colors } = useCurrentTheme();

  if (!children || children === '') {
    return null;
  }

  const helperTextColor = () => {
    if (isDisabled && !isSuccessful) {
      return invertColors
        ? colors.primary.white.base
        : colors.primary.black.lightest;
    } else if (hasError) {
      return colors.messaging.error[invertColors ? 'light' : 'dark'];
    } else if (isSuccessful) {
      return colors.messaging.success[invertColors ? 'light' : 'dark'];
    } else if (isWarning) {
      return colors.messaging.warning[invertColors ? 'light' : 'dark'];
    }

    return invertColors ? colors.primary.white.base : colors.primary.black.base;
  };
  return (
    <Typography
      as="div"
      data-qaid={qaId}
      pt={pt}
      fontSize={fontSize}
      color={helperTextColor()}
    >
      {children}
    </Typography>
  );
};
